import { render, staticRenderFns } from "./AgreementCard.vue?vue&type=template&id=71062108&scoped=true&"
import script from "./AgreementCard.vue?vue&type=script&lang=js&"
export * from "./AgreementCard.vue?vue&type=script&lang=js&"
import style0 from "./AgreementCard.vue?vue&type=style&index=0&id=71062108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71062108",
  null
  
)

export default component.exports